import { useEffect } from "react";
import { FeatureStatic } from "../../../../@types/statics/feature.static";
import usePermission from "../../../../hooks/usePermission";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { FormProjectStatus } from "../components/FormProjectStatus";

export const CreateProjectStatus: React.FC = () => {
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.projectStatus.id);

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
  }, []);

  return (
    <div className={styles.createCostCenter}>
      <FormProjectStatus pageType="create" />
    </div>
  );
};
